import React, { Component } from 'react';
import {connect} from "react-redux";
import { withTranslation } from "react-i18next";
import classNames from 'classnames';

import style from "./Note.scss";
import {setNote} from "../Store/Actions";

class Note extends Component
{
    constructor(props)
    {
        super(props);
        this.noteRef = React.createRef();
        this.inputRef = React.createRef();
        this.state = {
            editMode: false,
            note: 'Loading...'
        }
    }

    componentDidMount()
    {
        if(this.props.skinTrack) {
            this.setState({
                note: this.props.skinTrack.note || null
            });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot)
    {
        if (
            ! prevProps.skinTrack
            || this.props.skinTrack.id !== prevProps.skinTrack.id
            || this.props.skinTrack.revision !== prevProps.skinTrack.revision
        ) {
            this.setState({
                note: this.props.skinTrack.note || null
            });
        }

        if (this.state.editMode) {
            this.inputRef.current.focus();
        }
    }

    changeNote(e)
    {
        this.setState({note: e.target.value});
    }

    enableEditMode()
    {
        if(this.props.skinTrack.isLocked) {
            return;
        }

        this.setState({'editMode': true});
    }

    disableEditMode(e)
    {
        this.props.setNote(
            this.props.skinTrack.customer,
            this.props.skinTrack.id,
            e.target.value
        );

        this.setState({'editMode': false});
    }

    render()
    {
        const { t } = this.props;

        let classes = classNames({
            [style.note]: true,
            [style.hidden]: this.state ? this.state.editMode : false
        });
        let inputClasses = classNames({
            [style.inputNote]: true,
            [style.hidden]: this.state ? !this.state.editMode : true
        });

        return (
            <div className={style.notes}>
                <h3>{ t('Notes') }</h3>
                <p
                    className={classes}
                    onClick={(e) => this.enableEditMode(e)}
                    ref={this.noteRef}
                >
                    { this.state.note ? this.state.note : t('No notes found') }
                </p>
                <textarea
                    className={inputClasses}
                    onBlur={(e) => this.disableEditMode(e)}
                    onChange={(e)=>{this.changeNote(e)}}
                    value={ this.state.note ? this.state.note : '' }
                    ref={this.inputRef}
                />
            </div>
        )
    }
}

const mapStateToProps = function() {
    return {}
};

const mapDispatchProps = function(dispatch) {
    return {
        setNote: (customerId, skinTrackId, note) => dispatch(setNote(skinTrackId, customerId, note))
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchProps)(Note));
